import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import ajaxPromise from '../utils/ajaxPromise';

export const usageUpdate = createAsyncThunk('user/usageUpdate', async () => {
  const response = await ajaxPromise('/api/usage_update', 'GET');
  return response.data;
});

const slice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    loaded: false,
    organization: {},
    prospectorQueryState: null,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.loaded = true;
    },
    logoutSuccess: (state) => {
      state.user = null;
      state.loaded = false;
    },
    loaded: (state) => {
      state.loaded = true;
    },
    loading: (state) => {
      state.loaded = false;
    },
    addUserCapability: (state, action) => {
      if (state.user?.capabilities) {
        state.user.capabilities = [...state.user.capabilities, action.payload];
      } else {
        state.user.capabilities = [action.payload];
      }
    },
    incrementSemanticSearchCount: (state) => {
      state.user.semantic_search_count += 1;
    },
    updateProspectorQuery: (state, action) => {
      state.prospectorQueryState = action.payload;
    },
    updateOrganizationData: (state, action) => {
      state.organization.team_total_consumed_credits = action.payload?.team_total_consumed_credits;
      state.organization.team_total_remaining_credits =
        action.payload?.team_total_remaining_credits;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(usageUpdate.fulfilled, (state, action) => {
      if (state.user) {
        state.user.credits_remaining = action.payload.credits_remaining;
        state.user.credits_consumed = action.payload.credits_consumed;
      }
    });
  },
});
export default slice.reducer;

export const userActions = { ...slice.actions };
